<script>
import isArray from 'lodash/isArray'

export default {
  methods: {
    hasCategoryTypeMenuAttribute(item) {
      return Boolean(item.category_type) && isArray(item.category_type) && !item.category_type.includes('none')
    },
    isCustomMenuItem(item) {
      return this.hasCategoryTypeMenuAttribute(item) && item.category_type.includes('custom')
    },
    isStockMenuItem(item) {
      return this.hasCategoryTypeMenuAttribute(item) && item.category_type.includes('stock')
    },
  },
}
</script>
